import './App.css';

function App() {
  return (
    <div className="app-root">
      <header className="top-header">
        <span className="top-header-brand">Blockchain Games</span>
        <span className="top-header-divider">–</span>
        <span className="top-header-tagline">Next-generation on-chain gaming.</span>
      </header>

      <main className="hero">
        <img
          src="/finality.png"
          alt="Blockchain Games Finality"
          className="hero-logo"
        />
        <h1 className="hero-title">Finality</h1>

        <div className="store-links">
          <a href="#!" className="store-button disabled">
            <span className="store-label">App Store</span>
            <span className="store-status">Coming soon</span>
          </a>
          <a href="#!" className="store-button disabled">
            <span className="store-label">Google Play</span>
            <span className="store-status">Coming soon</span>
          </a>
        </div>
      </main>

      <footer className="site-footer">
        <div className="footer-links">
          <a
            href="mailto:blockchaindevwork@gmail.com"
            className="footer-link"
          >
            Contact
          </a>
          <span className="footer-separator">•</span>
          <a
            href="https://www.youtube.com/@blockchain_games"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            YouTube
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
